import {Config, MockConfig} from '../../config/types';
import {Shift, ShiftQueryparameters} from '../shifts/types';
import {MockData as memberships} from '../membership/mockdata';
import {getDatesInPeriod} from '../../utils';
import {TemplateSets, numericIdFactory, generateFromTemplate} from '../mocks';
import {Membership} from '../membership';

let cache: {[key: string]: Shift[]} = {};

type Template = {
  duration: number;
  startTime: string;
};

const templateSets: TemplateSets<Template> = {
  1: [
    [{duration: 6 * 60, startTime: '02:00:00'}],
    [{duration: 4 * 60, startTime: '06:00:00'}],
    [{duration: 8 * 60, startTime: '12:00:00'}],
  ],
  2: [
    [
      {duration: 4 * 60, startTime: '01:00:00'},
      {duration: 4 * 60, startTime: '11:00:00'},
    ],
    [
      {duration: 2 * 60, startTime: '06:00:00'},
      {duration: 6 * 60, startTime: '14:00:00'},
    ],
    [
      {duration: 2 * 60, startTime: '06:00:00'},
      {duration: 5.5 * 60, startTime: '19:00:00'},
    ],
  ],
};

const generateShift = (
  date: string,
  teamId: number,
  membership: Membership,
  template: Template,
): Shift => ({
  id: numericIdFactory(),
  membershipId: membership.id,
  teamId,
  distrDate: date,
  startTime: `${date}T${template.startTime}`,
  durationMinutes: template.duration,
});

export const generateShifts = (
  config: MockConfig,
  teamId: number,
  date: string,
  dependencies: {
    memberships: Membership[];
  },
): Shift[] => {
  let result: Shift[] = [];
  dependencies.memberships.forEach(m => {
    const shifts = generateFromTemplate(
      templateSets,
      config.ShiftCount,
      template => generateShift(date, teamId, m, template),
    );

    result.push(...shifts);
  });

  return result;
};

export const mockDataGenerator = (config: Config) => ({
  teamId,
  fromDate,
  toDate,
}: ShiftQueryparameters): Shift[] => {
  const dates = getDatesInPeriod(fromDate, toDate);
  let result: Shift[] = [];

  dates.forEach(d => {
    const key = `${teamId}:${d}`;
    if (!cache[key]) {
      cache[key] = generateShifts(config.Api.Mock, teamId, d, {memberships});
    }

    result.push(...cache[key]);
  });

  return result;
};
